/**
 * The search palette's recent picks, kept in this browser. Storage can be missing,
 * full or blocked (a private window, a storage policy), and the palette must still
 * open, so a failed read is an empty list and a failed write keeps the list for this
 * session only: the caller holds the list and passes it to the next write.
 */

const RECENT_SEARCHES_KEY = 'pnid.search.recent';
const RECENT_SEARCHES_KEPT = 5;

let storageFailureLogged = false;
// Once a session: a blocked storage fails on every pick, and one line says why.
function logStorageFailure(error: unknown) {
  if (storageFailureLogged) return;
  storageFailureLogged = true;
  console.warn('Recent searches are not kept past this session: storage is unavailable.', error);
}

/** The primaries of the last picks, newest first. */
export function readRecentSearches(): string[] {
  try {
    const stored: unknown = JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) ?? '[]');
    return Array.isArray(stored) ? stored.filter((entry): entry is string => typeof entry === 'string') : [];
  } catch (error) {
    logStorageFailure(error);
    return [];
  }
}

/** Moves `primary` to the front of `recent`, stores the result, and returns it. */
export function rememberRecentSearch(primary: string, recent: string[]): string[] {
  const next = [primary, ...recent.filter((entry) => entry !== primary)].slice(0, RECENT_SEARCHES_KEPT);
  try {
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(next));
  } catch (error) {
    logStorageFailure(error);
  }
  return next;
}
